// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".normalCard {\n    border-left: 6px solid #0071a4;\n    padding: 5px 10px;\n    width: 100%;\n}\n\n.errorCard {\n    border-left: 6px solid red;\n    padding: 5px 10px;\n    width: 100%;\n}\n\n.warningCard {\n    border-left: 6px solid yellow;\n    padding: 5px 10px;\n    width: 100%;\n}\n\n.informationCard {\n    border-left: 6px solid green;\n    padding: 5px 10px;\n    width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
